export const BODY_TYPES_IDS = {
  SEDAN: '1',
  COUPE: '2',
  CABRIO: '3',
  FAMILIAR: '4',
  MINIVAN: '5',
  SUV_4x4: '6',
  PICK_UP: '7',
  VANS: '8'
}

export const BODY_TYPES = {
  [BODY_TYPES_IDS.SEDAN]: {
    id: BODY_TYPES_IDS.SEDAN,
    imageSrc: 'form/body-berlina.png',
    name: 'BODY_TYPE_SEDAN'
  },
  [BODY_TYPES_IDS.COUPE]: {
    id: BODY_TYPES_IDS.COUPE,
    imageSrc: 'form/body-coupe.png',
    name: 'BODY_TYPE_COUPE'
  },
  [BODY_TYPES_IDS.CABRIO]: {
    id: BODY_TYPES_IDS.CABRIO,
    imageSrc: 'form/body-cabrio.png',
    name: 'BODY_TYPE_CABRIO'
  },
  [BODY_TYPES_IDS.FAMILIAR]: {
    id: BODY_TYPES_IDS.FAMILIAR,
    imageSrc: 'form/body-familiar.png',
    name: 'BODY_TYPE_FAMILIAR'
  },
  [BODY_TYPES_IDS.MINIVAN]: {
    id: BODY_TYPES_IDS.MINIVAN,
    imageSrc: 'form/body-monovolumen.png',
    name: 'BODY_TYPE_MINIVAN'
  },
  [BODY_TYPES_IDS.SUV_4x4]: {
    id: BODY_TYPES_IDS.SUV_4x4,
    imageSrc: 'form/body-4x4-suv.png',
    name: 'BODY_TYPE_4X4'
  },
  [BODY_TYPES_IDS.PICK_UP]: {
    id: BODY_TYPES_IDS.PICK_UP,
    imageSrc: 'form/body-pick-up.png',
    name: 'BODY_TYPE_PICK_UP'
  },
  [BODY_TYPES_IDS.VANS]: {
    id: BODY_TYPES_IDS.VANS,
    imageSrc: 'form/body-furgoneta.png',
    name: 'BODY_TYPE_VANS'
  }
}
